import { generateTestId } from "@client-shared";

export const setSearchViewTestId = (identifier: string): string =>
  generateTestId("SearchView", identifier);
